import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { subheaders } from 'features/common/Subheader/constants';
import { useCollapsible } from 'features/common/Subheader/hooks';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { possiblyCloseCollapseTypeTasks } from 'features/other/typeTasks/actions';

import TaskTable from './TaskTable';
import TaskTypeItemHeader from './TaskTypeItemHeader';

const TaskTypeItem = ({ taskType }) => {
	const dispatch = useDispatch();
	const subheaderId = `${subheaders.tasksOverview}_type_${taskType?.taskTypeId}`;
	const visibleState = useSelector((state) => getVisibleStateById(state, subheaderId, false));

	const { visible, handleToggle } = useCollapsible({ id: subheaderId, initiallyOpen: visibleState });

	useEffect(
		() => () => {
			dispatch(possiblyCloseCollapseTypeTasks(subheaderId));
		},
		[dispatch, subheaderId],
	);

	return (
		<Stack>
			<TaskTypeItemHeader taskType={taskType} handleToggle={handleToggle} visible={visible} />
			<Collapse in={visible} timeout={700}>
				<Paper sx={{ px: 3, py: 2, background: (theme) => theme?.palette?.background[100] }}>
					<TaskTable taskType={taskType} visible={visible} />
				</Paper>
			</Collapse>
			<Divider />
		</Stack>
	);
};

TaskTypeItem.propTypes = {
	taskType: PropTypes.object.isRequired,
};

export default TaskTypeItem;
